/**
 * Live countdown timer.
 * Works for any number of .countdown-timer elements on a page
 * (product page, collection grid, quick-view, etc).
 * Re-runs safely on Shopify section reloads / AJAX cart re-renders.
 */
function initCountdownTimers() {
  var timers = document.querySelectorAll('.countdown-timer[data-countdown-end]');

  timers.forEach(function (el) {
    // Avoid re-initializing an element that's already ticking
    if (el.dataset.countdownInit === 'true') return;
    el.dataset.countdownInit = 'true';

    var endTime = parseInt(el.getAttribute('data-countdown-end'), 10) * 1000;
    var daysEl = el.querySelector('.countdown-days');
    var hoursEl = el.querySelector('.countdown-hours');
    var minutesEl = el.querySelector('.countdown-minutes');
    var secondsEl = el.querySelector('.countdown-seconds');
    var intervalId;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var diff = endTime - Date.now();

      if (diff <= 0) {
        el.classList.add('is-expired');
        clearInterval(intervalId);
        return;
      }

      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    tick();
    intervalId = setInterval(tick, 1000);
  });
}

document.addEventListener('DOMContentLoaded', initCountdownTimers);
document.addEventListener('shopify:section:load', initCountdownTimers);
// Expose globally in case a theme needs to re-scan after dynamic content loads
window.initCountdownTimers = initCountdownTimers;
